import React from 'react'
import Sidebar from '../Profile/Sidebar'
import Feed from '../Global/Feed'
import SocialBar from '../Global/SocialBar'
/* REDUX */
import { connect } from 'react-redux'
import { loadUserReports } from '../../actions/user'
import { formatFeed, formatAPI } from '../../utility/Formatter'

const loadData = ({ user_id, category, loadUserReports }) => {
	loadUserReports(user_id, category)
}

class Content extends React.Component {
	
	componentWillMount() {
		loadData(this.props)
	}
	
	componentWillReceiveProps(nextProps) {
		if (nextProps.user_id !== this.props.user_id || nextProps.category !== this.props.category) {
			loadData(nextProps)
		}
	}
	
	handleLoadMoreClick = () => {
		this.props.loadUserReports(this.props.user_id, this.props.category, true)
	}
	
	render() {
		
		const { category, reports, endOfDoc, pathname, user } = this.props
		const type = pathname.params.type ? pathname.params.type : ''
		
		let feed = formatFeed(type)
		
		if (!reports) {
			return <div></div>
		}
				
		return (
			<section className="content">
				<div className="container">
					<div className="row">
						<div className="col-12 col-lg-2">
							<Sidebar pathname={ pathname } />
						</div>
						<div className="col-12 col-lg-3 push-lg-7">
							<SocialBar user={ user } />
						</div>
						<div className="col-12 col-lg-7 pull-lg-3">
							<Feed feed={ category } reports={ reports } onLoadMoreClick={ this.handleLoadMoreClick } endOfDoc={ endOfDoc } onLogin={ this.props.onLogin } />
						</div>
					</div>
				</div>
			</section>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	const user_id = ownProps.pathname.params.profile_id
	let category = formatAPI(ownProps.pathname.params.type)
	const {
		userById
	} = state
	const userWrapper = userById[user_id]
	const user = userWrapper.user
	const reportsByCategory = userWrapper['reportsByCategory']
	const reportsWrapper = reportsByCategory[category] || {}
	const reports = reportsWrapper.reports
	const endOfDoc = reportsWrapper.endOfDoc
	return {
		user,
		user_id,
		category,
		reports,
		endOfDoc
	}
}

export default connect(mapStateToProps, { loadUserReports })(Content)


// WEBPACK FOOTER //
// ./src/components/Profile/Content.js